import { definePreset } from '@primeuix/themes';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, REQUEST, inject } from '@angular/core';
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { InMemoryScrollingOptions, provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withFetch, withInterceptors, HttpInterceptorFn } from "@angular/common/http";
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { authInterceptor } from './auth.interceptor';

const absoluteUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/')) {
    return next(req);
  }
  const serverRequest = inject(REQUEST, { optional: true });
  if (!serverRequest) {
    return next(req);
  }
  const origin = new URL(serverRequest.url).origin;
  return next(req.clone({ url: `${origin}${req.url}` }));
};
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const truckHandelPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling(scrollConfig), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        absoluteUrlInterceptor,
        authInterceptor
      ])
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'de',
      lang: 'de'
    }),
    providePrimeNG({
      theme: {
        preset: truckHandelPreset,
        options: {
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
          }
        }
      }
    }), provideClientHydration(
      withHttpTransferCacheOptions({
        includeHeaders: ['X-Total-Count']
      }),
      withEventReplay()
    )
  ]
};

